import axios from 'axios';
import { sendGAEvent } from '@next/third-parties/google';

export const notifyLandingRegister = async (
    phone: string,
    token: string,
    landingSlug?: string,
    httpReferer?: string,
) => {
    if (!landingSlug) return;

    try {
        const response = await axios.post(
            '/api/auth/landing-register',
            { landingSlug, httpReferer, phone },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
        if (landingSlug === 'nokhbegan' || landingSlug === 'nokhbegan-main') {
            sendGAEvent('event', 'nokhbeganRegister', { value: 'nokhbeganRegister' });
        }
        return response.data;
    } catch (err: any) {
        console.warn('Landing register failed:', err?.response?.data || err.message);
    }
};
